import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import withUser from '../decorators/withUser';
import AddressForm, { mapUserToAddress } from '../components/AddressForm';
import { getAddressSubmitSucceeded } from '../reducers';
import { createAddress } from '../actions/addresses';

class CreateAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      useDefault: false,
      defaultAddress: {},
    };
    this.useDefaultAddress = this.useDefaultAddress.bind(this);
  }

  useDefaultAddress() {
    this.setState({
      useDefault: true,
      defaultAddress: {
        ...this.props.formValues,
        address1: '55 Broadway Ave',
        address2: '',
        city: 'New York',
        state: 'NY',
        country: 'USA',
        zip_code: '10006',
      },
    });
  }

  render() {
    const { onSubmit, userId, submitSucceeded, ...props } = this.props;
    const { useDefault, defaultAddress } = this.state;

    if (submitSucceeded) {
      return <Redirect to={`/users/${userId}/view`} />;
    }

    return (
      <div>
        <button
          className="btn btn-default mar-b"
          onClick={this.useDefaultAddress}
        >
          Use Default Address
        </button>

        <br />

        {useDefault ? (
          <AddressForm
            {...props}
            initialValues={defaultAddress}
            onSubmit={(values) => {
              return onSubmit({
                ...values,
                user_profile: userId,
              });
            }}
          />
        ) : (
          <AddressForm
            {...props}
            onSubmit={(values) => {
              return onSubmit({
                ...values,
                user_profile: userId,
              });
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { user }) => ({
  submitSucceeded: getAddressSubmitSucceeded(state),
  formValues: getFormValues('address')(state),
  initialValues: user && mapUserToAddress(user),
});

const mapDispatchToProps = {
  onSubmit: createAddress,
};

CreateAddress = withUser(
  connect(mapStateToProps, mapDispatchToProps)(CreateAddress),
);

export default CreateAddress;
